<script setup lang="ts">
    interface GeometryLineProps {
        label: string;
        type: string;
        value: string;
        index?: number;
        selected?: boolean;
    }
    const props = withDefaults(defineProps<GeometryLineProps>(), {
        index: 0,
        selected: false,
    });

    const emit = defineEmits(['click', 'hover']);

    const toggleSelect = () => {
        if (!props.selected) {
            emit('click', props.type);
        } else {
            emit('click', undefined);
        }
    };
</script>

<template>
    <button
        v-if="value !== ''"
        :class="['atm-geometry-line flex gap-2 text-left transition-colors hover:text-woom-red', { selected: selected }]"
        @mouseover="$emit('hover', type)"
        @mouseout="$emit('hover', null)"
        @click="toggleSelect"
        @focus="$emit('hover', type)">
        <span class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-black text-xs font-bold leading-6 text-white">
            {{ 'ABCDEFGHIJKLMNOP'[index] }}
        </span>

        <span class="flex w-full justify-between">
            <span class="w-2/3 font-bold">{{ label }}</span>

            <span class="w-1/3 text-left">
                <renderer-html :content="woomTextFormat(value)" />
            </span>
        </span>
    </button>
</template>
